import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, ApiError, type CohortRow } from '../../api';
import { useSession } from '../../session';

export function Cohorts() {
  const [rows, setRows] = useState<CohortRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const { user } = useSession();
  const navigate = useNavigate();
  const canCreate = user?.permissions.some(p => p === 'administrator.groups.create' || 'administrator.groups.create'.startsWith(p + '.'));
  useEffect(() => { api.get<{ groups: CohortRow[] }>('/admin/groups').then((r) => setRows(r.groups)).catch(e => setError((e as ApiError).message)); }, []);

  if (!rows) return <p className={error ? 'auth__error' : 'muted'}>{error ?? 'Loading…'}</p>;

  return (
    <>
      <h1 className="h1">Cohorts</h1>
      <p className="muted">A cohort is a group of trainees who move through the same courses together.</p>
      {error && <p role="alert" className="auth__error">{error}</p>}
      {canCreate && <form className="panel" onSubmit={async e => {
        e.preventDefault(); setBusy(true); setError(null);
        try { const result = await api.post<{ group: { id: number } }>('/admin/groups', { name, autoEnroll: true }); navigate(`/admin/cohorts/${result.group.id}`); }
        catch (err) { setError((err as ApiError).message); } finally { setBusy(false); }
      }}>
        <label>Cohort name <input value={name} onChange={e => setName(e.target.value)} required maxLength={150} disabled={busy} /></label>{' '}
        <button className="btn" disabled={busy || !name.trim()}>Create cohort</button>
      </form>}
      <table className="grid">
        <thead><tr><th>Cohort</th><th>People</th><th>Courses</th><th>Auto-enrol</th><th>Join key</th></tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={5} className="muted">No cohorts yet.</td></tr>}
          {rows.map((g) => (
            <tr key={g.id}>
              <td>
                <Link to={`/admin/cohorts/${g.id}`}>{g.name}</Link>
                {g.description && <div className="muted small">{g.description}</div>}
              </td>
              <td className="num">{g.memberCount}</td>
              <td className="num">{g.courseCount}</td>
              <td className="muted">{g.autoEnroll ? 'yes' : 'no'}</td>
              <td className="mono muted small">{g.groupKey ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
